export default "__VITE_ASSET__375e8dd2__"